import PubSub from 'vanilla-pubsub'
import { throttle, isMobile, getBrowser } from './utils'

class ProjectBase {
  constructor() {
    this.modules = {}
    this.$window = {
      isMobile: isMobile(),
      browser: getBrowser(),
      width: window.innerWidth,
      height: window.innerHeight,
      scrollX: window.pageXOffset,
      scrollY: window.pageYOffset,
    }
    this.scrollBarWidth = window.innerWidth - document.body.clientWidth
    this._bind()
  }

  get state() {
    return this.$window
  }

  _bind() {
    this._onScroll = this._onScroll.bind(this)
    this._onResize = throttle(this._onResize.bind(this), 200)
    this._scrollDisable = this._scrollDisable.bind(this)
    this._scrollRelease = this._scrollRelease.bind(this)

    window.addEventListener('scroll', this._onScroll)
    window.addEventListener('resize', this._onResize)

    PubSub.subscribe('App.methods.scroll.disable', this._scrollDisable)
    PubSub.subscribe('App.methods.scroll.release', this._scrollRelease)
  }

  _onScroll() {
    this.$window.scrollX = window.pageXOffset
    this.$window.scrollY = window.pageYOffset
    PubSub.publish('App.scroll.sensitive', this.state)

    throttle(() => {
      PubSub.publish('App.scroll', this.state)
    }, 200)()
  }

  _onResize() {
    const oldState = this.$window.isMobile
    this.$window.width = window.innerWidth
    this.$window.height = window.innerHeight
    this.$window.isMobile = isMobile()

    PubSub.publish('App.resize', this.state)

    if (oldState !== this.$window.isMobile) {
      PubSub.publish('App.break', this.state)
    }
  }

  _scrollDisable() {
    document.body.style.paddingRight = `${this.scrollBarWidth}px`
    document.documentElement.classList.add('is-disable-scroll')
  }

  _scrollRelease() {
    document.documentElement.classList.remove('is-disable-scroll')
    document.body.style.paddingRight = ''
  }

  addModule(name, instance) {
    this.modules[name] = instance
  }
}

export default new ProjectBase()
